import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { getMinireport } from './actions'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'id', null)

    return {
        isLoading: state.getIn(['ui', 'minireport', id, 'isLoading'], false),
        isLoaded: state.getIn(['ui', 'minireport', id, 'isLoaded'], false),
        isFailed: state.getIn(['ui', 'minireport', id, 'isFailed'], false),
        data: state.getIn(['ui', 'minireport', id, 'data'], null),
    }
}

export function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getMinireport }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
